import React from 'react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import CreateCustomerPayment from '../../../components/CustomerPayment/CreateCustomerPayment.js';

export default function CustomerPayments() {
  return (
    <AdminPageShell title="Recibos">
      <CreateCustomerPayment />
    </AdminPageShell>
  );
}
